import { MessageCircle, CalendarDays } from "lucide-react";

const MobileContactBar = () => {
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-center gap-3 px-4 py-3">
        <a
          href="https://wa.me/34614541275"
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 inline-flex items-center justify-center gap-2 h-11 rounded-full bg-[#075E54] text-white text-sm font-medium"
        >
          <MessageCircle size={18} />
          WhatsApp
        </a>
        <a
          href="https://agenda.vibralabs.es/rosysanzonetty/consultoria-con-rosy"
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 inline-flex items-center justify-center gap-2 h-11 rounded-full bg-primary text-primary-foreground text-sm font-medium"
        >
          <CalendarDays size={18} />
          Consultoría
        </a>
      </div>
    </div>
  );
};

export default MobileContactBar;
